export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-[#F9F9F6] border-t border-[#E2E5E0]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-14">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-6">
            <div className="font-heading text-[15px] tracking-[0.42em] font-medium text-[#152219]">
              NUMA
            </div>
            <div className="text-[11px] tracking-[0.28em] uppercase text-[#8A9A90] mt-2">
              Regenaceutical — Precision Longevity Architecture
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <div className="flex flex-col md:flex-row md:justify-end gap-4 md:gap-10 text-[11px] tracking-[0.22em] uppercase text-[#57635A]">
              <span data-testid="footer-domain">numaregen.com</span>
              <span data-testid="footer-product">NR-05 / NMN-05</span>
              <span data-testid="footer-year">© {year}</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#E2E5E0] flex flex-col sm:flex-row justify-between gap-3 text-[10px] tracking-[0.22em] uppercase text-[#8A9A90]">
          <span>
            These statements have not been evaluated by any regulatory agency.
          </span>
          <span>Manufactured under clinical specification.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
